
export const SERVER_URL = process.env.REACT_APP_API_SERVER_URL
export const FIREBASE_CONFIG = {
    apiKey : process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain : process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId : process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId : process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId : process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
}

export const AppRoutes = {
    "KIOSK": {
        "KITCHEN_MODULES" : "", //Default route
        "GOD_MODE" : "godMode",
        "FOODMAKING" : "foodmaking"
    },
    "INVENTORY" : {
        "INVENTORY_SNAPSHOT" : "inventory",
        "REPLENISH" : "replenish",
    },
    "TASKS" : {
        "RECENT_TASKS" : "task/recent",
        "TASK" : "task/:taskId",
		"ACTIVE_TASKS" : "task/active",
		"SEARCH_TASKS" : "task/search"
    },
	"OPERATIONS": {
		"XOOKEEPER_PLANNED_TASKS" : "xookeeper/tasks/planned",
		"XOOKEEPER_PAST_TASKS": "xookeeper/tasks/past"
	},
    "ORDERS" : {
        "RECENT_ORDERS" : "order/recent",
        "ORDER_DETAILS" : "order/details/:id"
    },
	"STUDIO" : {
		"DEFAULT" : "/studio",
		"DISH_LIST" : "dish",
		"DISH_EDIT" : "dish/:dishId/edit",
		"DISH_CREATE" : "dish/create",
		"DISH_DETAILS" : "dish/:id",
		"INGREDIENT_LIST" : "ingredient",
		"INGREDIENT_EDIT" : "ingredient/:id/edit",
		"INGREDIENT_DETAILS" : "ingredient/:id",
		"INGREDIENT_CREATE" : "ingredient/create",
		"RECIPE_LIST" : "",
		"RECIPE_EDIT" : "recipe/:id/edit",
		"RECIPE_DETAILS" : "recipe/:id",
		"RECIPE_CREATE" : "recipe/create"
	}
}

export const SidebarLinks = {
	"KIOSK" :{
		"title" : "Kiosk",
		"hasSubLinks" : true,
		"isMaterialIcon": true,
		"icon" : "oven_gen",
		"subLinks" : [
			{
				"title" : "Kitchen Modules",
				"link" : AppRoutes.KIOSK.KITCHEN_MODULES,
				"isMaterialIcon" : true,
				"icon" : "apps"
			},
			{
				"title" : "God Mode",
				"link" : AppRoutes.KIOSK.GOD_MODE,
				"isMaterialIcon" : true,
				"icon" : "stadia_controller",
			},
			// {
			// 	"title" : "Live Stream",
			// 	"link" : AppRoutes.KIOSK.LIVE_STREAM,
			// 	"isMaterialIcon" : true,
			// 	"icon" : "live_tv"
			// },
            {
				"title" : "Foodmaking",
				"link" : AppRoutes.KIOSK.FOODMAKING,
				"isMaterialIcon" : true,
				"icon" : "task"
			},
		]
	},
	"INVENTORY" :{
		"title" : "Inventory",
		"hasSubLinks" : true,
        "isMaterialIcon": true,
		"icon" : "package_2",
		"subLinks" : [
			{
				"title" : "Snapshot",
				"link" : AppRoutes.INVENTORY.INVENTORY_SNAPSHOT,
				"isMaterialIcon" : true,
				"icon" : "inventory_2"
			},
			{
				"title" : "Replenish",
				"link" : AppRoutes.INVENTORY.REPLENISH,
				"isMaterialIcon" : true,
				"icon" : "inventory"
			},
		]
	},
	"TASKS" : {
		"title" : "Tasks",
		"hasSubLinks" : true,
        "isMaterialIcon": true,
		"icon" : "add_task",
		"subLinks" : [
			{
				"title" : "Recent Tasks",
				"link" : AppRoutes.TASKS.RECENT_TASKS,
				"isMaterialIcon" : true,
				"icon" : "list_alt"
			},
			{
				"title" : "Search Tasks",
				"link" : AppRoutes.TASKS.SEARCH_TASKS,
				"isMaterialIcon" : true,
				"icon" : "order_play"
			},
			{
				"title" : "Active Tasks",
				"link" : AppRoutes.TASKS.ACTIVE_TASKS,
				"isMaterialIcon" : true,
				"icon" : "order_play"
			}
		]
	},
	"OPERATIONS" : {
		"title" : "Operations",
		"hasSubLinks" : true,
        "isMaterialIcon": true,
		"icon" : "add_task",
		"subLinks" : [
			{
				"title" : "Xookeeper",
				"link" : AppRoutes.OPERATIONS.XOOKEEPER_PLANNED_TASKS,
				"isMaterialIcon" : true,
				"icon" : "list_alt"
			}
		]
	},
	"ORDERS" : {
		"title" : "Orders",
		"hasSubLinks" : true,
        "isMaterialIcon": true,
		"icon" : "orders",
		"subLinks" : [
			{
				"title" : "Recent Orders",
				"link" : AppRoutes.ORDERS.RECENT_ORDERS,
				"isMaterialIcon" : true,
				"icon" : "list_alt"
			},
		]
	}
}

export const StudioSideBarLinks = {
	// "DISH" : {
	// 	"title" : "Dish",
	// 	"hasSubLinks" : true,
	// 	"isMaterialIcon": true,
	// 	"icon" : "oven_gen",
	// 	"subLinks" : [
	// 		{
	// 			"title" : "Dishes List",
	// 			"link" : AppRoutes.STUDIO.DISH_LIST,
	// 			"isMaterialIcon" : true,
	// 			"icon" : "apps"
	// 		},
	// 		// {
	// 		// 	"title" : "Create Dish",
	// 		// 	"link" : AppRoutes.STUDIO.DISH_CREATE,
	// 		// 	"isMaterialIcon" : true,
	// 		// 	"icon" : "stadia_controller",
	// 		// },
	// 	]
	// },
	"INGREDIENT" : {
		"title" : "Ingredient",
		"hasSubLinks" : true,
		"isMaterialIcon": true,
		"icon" : "oven_gen",
		"subLinks" : [
			{
				"title" : "Ingredients List",
				"link" : AppRoutes.STUDIO.INGREDIENT_LIST,
				"isMaterialIcon" : true,
				"icon" : "apps"
			},
			{
				"title" : "Create Ingredient",
				"link" : AppRoutes.STUDIO.INGREDIENT_CREATE,
				"isMaterialIcon" : true,
				"icon" : "stadia_controller",
			},
		]
	},
	"RECIPE" : {
		"title" : "Recipe",
		"hasSubLinks" : true,
		"isMaterialIcon": true,
		"icon" : "oven_gen",
		"subLinks" : [
			{
				"title" : "Recipes List",
				"link" : AppRoutes.STUDIO.RECIPE_LIST,
				"isMaterialIcon" : true,
				"icon" : "apps"
			},
			{
				"title" : "Create Recipe",
				"link" : AppRoutes.STUDIO.RECIPE_CREATE,
				"isMaterialIcon" : true,
				"icon" : "stadia_controller",
			},
		]
	}
}